import Script from "next/script";
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

/**
 * Loads GTM for every visitor. Consent is enforced through Google Consent Mode
 * v2: `GOOGLE_CONSENT_DEFAULT` (injected `beforeInteractive` from
 * `_document.tsx`) denies storage before this runs, and Iubenda
 * (`googleConsentMode: true`) pushes the updates. Google tags fire in
 * cookieless modeling mode until the visitor accepts, rather than the
 * container not loading at all.
 *
 * Because the container is no longer gated behind consent, every NON-Google tag
 * inside the GTM container (custom HTML, LinkedIn/Meta pixels, etc.) must carry
 * its own consent requirement in GTM; only Google tags respect Consent Mode
 * automatically.
 */
export function GoogleTagManagerScript() {
  if (!GTM_ID) {
    return null;
  }
  return <Script id="google-tag-manager" strategy="lazyOnload" dangerouslySetInnerHTML={{
    __html: `
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', '${GTM_ID}');
    `
  }} />;
}